// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { bulkAddProductLocations } from "./schema/bulk-add-product-locations";
import { bulkUpdateProductPrices } from "./schema/bulk-update-product-prices";
import { getDashboard } from "./schema/dashboard/get-dashboard";
import { bulkUpdateForecastingFields } from "./schema/forecasting/bulk-update-forecasting-fields";
import { enrollImsBilling } from "./schema/forecasting/enroll-ims-billing";
import { getProductSkus } from "./schema/forecasting/get-product-skus";
import { getProductSources } from "./schema/forecasting/get-product-sources";
import { getProductTags } from "./schema/forecasting/get-product-tags";
import { getProductVendors } from "./schema/forecasting/get-product-vendors";
import { getVariantTags } from "./schema/forecasting/get-variant-tags";
import { getImsPricingInfo } from "./schema/forecasting/ims-pricing";
import {
  createPurchaseOrderRecommendationRule,
  deletePurchaseOrderRecommendationRule,
  dismissPurchaseOrderRecommendations,
  draftPurchaseOrdersFromRecommendations,
  getPurchaseOrderRecommendationRules,
  listGroupedPurchaseOrderRecommendations,
  runPurchaseOrderRecommendationRule,
  snoozePurchaseOrderRecommendations,
  unsnoozePurchaseOrderRecommendations,
  updatePurchaseOrderRecommendationRule,
} from "./schema/forecasting/purchase-order-recommendations";
import { disconnectGoogleMerchantCenter } from "./schema/google-merchant-center/disconnect-google-merchant-center";
import { getGoogleMerchantCenterIntegration } from "./schema/google-merchant-center/get-google-merchant-center-integration";
import { getGoogleMerchantCenterOAuthURL } from "./schema/google-merchant-center/get-google-merchant-center-oauth-url";
import { getMerchantCenterAccounts } from "./schema/google-merchant-center/get-merchant-center-accounts";
import { getUcpManifest } from "./schema/google-merchant-center/get-ucp-manifest";
import { updateGoogleMerchantCenterIntegration } from "./schema/google-merchant-center/update-google-merchant-center-integration";
import { getHsCodes } from "./schema/hs-code-finder/get-hs-codes";
import { searchHsCodes } from "./schema/hs-code-finder/search-hs-codes";
import { getHistoricalSales } from "./schema/scenario-planning/get-historical-sales";
import { runScenarioForecast } from "./schema/scenario-planning/run-scenario-forecast";

export const groupB = {
  bulkAddProductLocations,
  bulkUpdateProductPrices,
  bulkUpdateForecastingFields,
  createPurchaseOrderRecommendationRule,
  enrollImsBilling,
  deletePurchaseOrderRecommendationRule,
  dismissPurchaseOrderRecommendations,
  draftPurchaseOrdersFromRecommendations,
  getDashboard,
  listGroupedPurchaseOrderRecommendations,
  getPurchaseOrderRecommendationRules,
  getProductSkus,
  getProductSources,
  getProductTags,
  getProductVendors,
  getVariantTags,
  getImsPricingInfo,
  runPurchaseOrderRecommendationRule,
  snoozePurchaseOrderRecommendations,
  unsnoozePurchaseOrderRecommendations,
  updatePurchaseOrderRecommendationRule,
  disconnectGoogleMerchantCenter,
  getGoogleMerchantCenterIntegration,
  getGoogleMerchantCenterOAuthURL,
  getMerchantCenterAccounts,
  getUcpManifest,
  updateGoogleMerchantCenterIntegration,
  getHistoricalSales,
  runScenarioForecast,
  getHsCodes,
  searchHsCodes,
};
